import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useModalForm } from "../../../../utils/hooks/useModalForm";
import MainPagetitle from "../../../layouts/MainPagetitle";
import EmployeesSearch from "./EmployeesSearch";
import moment from "moment";

const Employees = (props) => {
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [totalPageChange, setTotalPageChange] = useState({
    page: 1,
    limit: 10,
  });
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [rowcount, setRowcount] = useState(0);
  const [employeeId, setEmployeeId] = useState(null);
  const columns = [
    {
      dataIndex: "full_name",
      title: "Email Name",
      render: (text, record) => {
        return (
          <>
            <span
              className="table-primary-text text-decoration-underline cursor-pointer"
              onClick={(e) => view(record)}
            >
              {text}
            </span>
          </>
        );
      },
    },
    {
      dataIndex: "mobile_number",
      title: "Mobile No.",
    },
    {
      dataIndex: "email_address",
      title: "Email",
    },
    {
      dataIndex: "joining_date",
      title: "Joining Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    {
      dataIndex: "role",
      title: "Role",
      render: (text, record) => {
        return _enum.ROUTE_PERSONAS_TEXT[text] || text;
      },
    },
    {
      dataIndex: "state",
      title: "Location",
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (text, record) => {
        let mappedStatus =
          _enum.STATUS_COLOR_MAP[record?.status?.toLowerCase()] || "";
        return (
          <Dropdown
            className={Object.className({
              "status-dropdown": true,
              "no-arrow pe-none": true,
            })}
          >
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record.status.toTitleCase()}</span>
              <i class="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];

  // ----------------------------------------------------------------
  const modalConfigs = {
    employee: [
      {
        label: "Employee Name",
        name: "full_name",
        type: "text",
        placeholder: "Please Enter",
        required: true,
        rules: _enum.ONLY_STRING_RULE,
      },
      {
        label: "Role",
        name: "role",
        type: "select",
        options: [],
        fetchKey: "role",
        fetchOptions: async () => {
          const data = await props.apis.apiGetMasterStaticValues();
          if (data)
            return data?.roles?.filter((v) => v !== "ADMINISTRATOR")?.options();
          return [];
        },
        required: true,
      },
      {
        label: "Designation",
        name: "designation",
        type: "select",
        options: [],
        required: true,
      },
      {
        label: "Email ID",
        name: "email_address",
        type: "email",
        placeholder: "Please Enter",
        rules: _enum.EMAIL_RULE,
        required: true,
        disableOnEdit: true,
      },
      {
        label: "Mobile No.",
        name: "mobile_number",
        type: "text",
        placeholder: "Please Enter",
        rules: _enum.MOBILE_NUM_RULE,
        required: true,
        disableOnEdit: true,
      },
      {
        label: "Work Location",
        name: "work_location_name",
        type: "select",
        options: [],
        fetchKey: "location_name",
        fetchOptions: async () => {
          const data = await props.apis.apiGetMasterLocations();
          if (data) return data?.options("location_name");
          return [];
        },
        placeholder: "Please Select",
      },
      {
        label: "State",
        name: "state",
        type: "text",
        placeholder: "Auto populated",
        readOnly: true,
      },
      {
        label: "City",
        name: "city",
        type: "text",
        placeholder: "Auto populated",
        readOnly: true,
      },
      {
        label: "Reporting Manager",
        name: "supervisor_id",
        type: "text",
        placeholder: "Please Select",
        required: true,
      },
      {
        name: "joining_date",
        label: "Joining Date",
        type: "date",
        disabledDate: (current) => {
          return current && current > moment().endOf("day");
        },
        placeholder: "Please enter",
      },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.EMPLOYEE_STATUS,
        placeholder: "Please Select",
        required: true,
      },
      {
        name: "effective_date",
        label: "Effective Date",
        type: "date",
        showWhen: (values) => values.status === "INACTIVE",
        placeholder: "Please enter",
        required: true,
      },
    ],
  };

  const dependencies = {
    role: (role) => {
      let designationOptions = _enum.ROLE_BASED_DESIGNATIONS[role];
      console.log({ role, designationOptions });

      return {
        fieldUpdates: {
          designation: { options: designationOptions },
        },
        valueUpdates: {
          designation: null,
        },
      };
    },
    work_location_name: async (value) => {
      if (value) {
        const res = await props.apis.apiGetLocationByName({
          location_name: value,
        });
        if (res) {
          return {
            valueUpdates: {
              state: res?.state,
              city: res?.city,
            },
          };
        }
      }
      return {};
    },
  };

  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, dependencies);

  const openApplicationModal = () => {
    let defaultValues = {
      status: "ACTIVE",
      effective_date: new Date().toISOString(),
    };
    openModal("employee", "add", "Add Employee", defaultValues);
  };

  const view = async (record) => {
    const data = await props.apis.apiGetEmployeeById({
      employee_id: record.employee_id,
    });
    openModal("employee", "view", "View Employee", { ...data });
  };

  const edit = async (record) => {
    const data = await props.apis.apiGetEmployeeById({
      employee_id: record.employee_id,
    });
    setEmployeeId(record.employee_id);
    openModal("employee", "edit", "Edit Employee", { ...data });
  };

  const deleteEmployee = (record) => {
    swal2
      .fire({
        title: "Are you sure you want to delete this Employee?",
        icon: "info",
        iconColor: "#234C9B",
        showCancelButton: true,
        confirmButtonColor: "#234C9B",
        cancelButtonColor: "##D6DBE7",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
      .then((result) => {
        if (result.isConfirmed) {
          props.apis
            .apiDeleteEmployee({ employee_id: record.employee_id })
            .then((res) => {
              swal2.fire({
                title: "Employee Deleted",
                text: "Employee deleted successfully !!",
                icon: "success",
                iconColor: "#234C9B",
                timer: 4000,
              });
              getEmployees();
            });
        }
      });
  };

  const handleAppModalSubmit = async (data) => {
    let payload = {
      ...data,
    };
    if (modalState.mode === "edit" && modalState.type === "employee") {
      const res = await props.apis.apiUpdateEmployee(payload, {
        employee_id: employeeId,
      });
      if (res) {
        swal2.fire({
          title: "Employee updated successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        closeModal();
        getEmployees();
      }
    }
    if (modalState.mode === "add" && modalState.type === "employee") {
      const res = await props.apis.apiAddEmployee(payload);
      console.log({ res });

      if (res) {
        swal2.fire({
          title: "Employee added successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        closeModal();
        getEmployees();
      }
    }
  };
  // ----------------------------------------------------------------
  const downloadExcel = async () => {
    let payload = {};
    props.apis.apiExportEmployees(payload).then(async (res) => {
      if (res) {
        let data = await res;
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `Employees_Details.xlsx`);
        link.click();
      }
    });
  };
  // ----------------------------------------------------------------

  const onPageChange = (pageData) => {
    setTotalPageChange({
      ...search,
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };

  const getEmployees = (params = {}, reset) => {
    // console.log({ params, reset });
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, ["limit", "page"]);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
      // console.log({ defaultSearchData: payload });
    } else {
      payload = {
        ...search,
        ...params,
      };
    }
    props.apis.apiGetAllEmployees(payload).then(({ data, total }) => {
      console.log({ apiGetAllEmployees: data, total });
      setTableData(data);
      setIsFetching(false);
      setRowcount(total);
    });
  };

  const onSearch = (data, reset) => {
    // console.log("onSearch on digirep", data, reset);
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getEmployees(data, reset);
    } else {
      setSearch({
        ...data,
        ...search,
      });
      getEmployees(data, reset);
    }
  };

  useEffect(() => {
    getEmployees(totalPageChange);
  }, [totalPageChange]);

  return (
    <>
      <MainPagetitle
        mainTitle="Employees"
        pageTitle={"Employees"}
        parentTitle={"Home"}
        pageIcon={imagepaths.LeadsIconActive}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <EmployeesSearch
                  inactive={props.inactive}
                  onSearch={(...arg) => onSearch(...arg)}
                  onAddModalFields={(...args) => openApplicationModal(...args)}
                  downloadExcel={(...args) => downloadExcel(...args)}
                />
                <AppTable
                  data={tableData}
                  columns={columns}
                  onChange={(...arg) => onPageChange(...arg)}
                  total={rowcount}
                  reorder={true}
                  editAction={(e) => edit(e)}
                  viewAction={(e) => view(e)}
                  deleteAction={(e) => deleteEmployee(e)}
                  loading={isFetching}
                ></AppTable>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AppFormModal
        form={appform}
        title={modalState.title}
        open={modalState.open}
        onValuesChange={handleValuesChange}
        onClose={closeModal}
        fields={modalState.fields}
        onSubmit={handleAppModalSubmit}
        mode={modalState.mode}
        persona={props?.$store?.user?.role}
      />
    </>
  );
};

export default constore(Employees);
